module.exports = __webpack_public_path__ + "static/img/report_img_bjstggaqyb.975ad07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_bjstggaqyb.png
// module id = iJfk
// module chunks = 21